import { clsx, type ClassValue } from "clsx"
import { twMerge } from "tailwind-merge"
import { SleepFixError } from "./types"

export function cn(...inputs: ClassValue[]) {
  return twMerge(clsx(inputs))
}


export const mockError: SleepFixError = {
  fileName: "TransactionHeader.tsx",
  lineNumber: 32,
  characterNumber: 44,
  errorMessage: `Uncaught TypeError: Cannot read properties of undefined (reading 'ass')
    at onClick (TransactionHeader.tsx:32:44)`,
  stackTrace: `at onClick (TransactionHeader.tsx:32:44)
        at HTMLUnknownElement.callCallback (react-dom.development.js:20565:1)
        at Object.invokeGuardedCallbackImpl (react-dom.development.js:20614:1)
        at invokeGuardedCallback (react-dom.development.js:20689:1)
        at invokeGuardedCallbackAndCatchFirstError (react-dom.development.js:20703:1)
        at executeDispatch (react-dom.development.js:32128:1)
        at processDispatchQueueItemsInOrder (react-dom.development.js:32160:1)
        at processDispatchQueue (react-dom.development.js:32173:1)
        at dispatchEventsForPlugins (react-dom.development.js:32184:1)
        at eval (react-dom.development.js:32374:1)
        at batchedUpdates$1 (react-dom.development.js:24953:1)
        at batchedUpdates (react-dom.development.js:28844:1)
        at dispatchEventForPluginEventSystem (react-dom.development.js:32373:1)
        at dispatchEvent (react-dom.development.js:30141:1)
        at dispatchDiscreteEvent (react-dom.development.js:30112:1)`

}

export function generateRandomAlphanumeric(length: number): string {
  const characters =
    "ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789";
  let result = "";
  const charactersLength = characters.length;

  for (let i = 0; i < length; i++) {
    result += characters.charAt(Math.floor(Math.random() * charactersLength));
  }

  return result;
}


export const githubOwner = 'tenfef';
export const githbuRepo = 'SleepFix';